export default {
  sales: [],
  sale: {}
}